// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Search: React.FC<{ width?: number; height?: number }> = ({ width = 16, height = 16 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16">
            <path
                fill="currentColor"
                d="M13,6.5 C13,7.9375 12.53125,9.25 11.75,10.34375 L15.71875,14.28125 C16.09375,14.6875 16.09375,15.3125 15.71875,15.71875 C15.3125,16.09375 14.6875,16.09375 14.28125,15.71875 L10.34375,11.75 C9.25,12.53125 7.9375,13 6.5,13 C2.90625,13 0,10.09375 0,6.5 C0,2.90625 2.90625,0 6.5,0 C10.09375,0 13,2.90625 13,6.5 Z M6.5,11 C9,11 11,9 11,6.5 C11,4 9,2 6.5,2 C4,2 2,4 2,6.5 C2,9 4,11 6.5,11 Z"
            />
        </svg>
    );
};

export default React.memo(Search);
